// extracted by mini-css-extract-plugin
module.exports = {"AnswerItem":"AnswerItem_AnswerItem__BfScg","success":"AnswerItem_success__33WEN","error":"AnswerItem_error__wq5cF"};